import Card from '../components/common/Card';
import PageHero from '../components/layout/PageHero';

function UpcomingProjects() {
  return (
    <>
      <PageHero
        eyebrow="More"
        title="Upcoming Projects"
        description="Future FactorStreet initiatives and product directions will be introduced here."
      />
      <section className="section page-content">
        <div className="container">
          <Card>
            <h2>Content will be added soon</h2>
            <p>
              This page will share upcoming product, platform, and education initiatives as they
              become ready for public announcement.
            </p>
          </Card>
        </div>
      </section>
    </>
  );
}

export default UpcomingProjects;
